export { default } from "./LocationSearch.gql";
